import { Divider, Modal } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { CredusButton, CredusText, CredusWrapper } from 'ui';

interface SignOutModalProps {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  openModal: boolean;
  onSignOutModalOpen: () => void;
}

const SignOutModal: FC<SignOutModalProps> = ({
  onSignOutModalOpen,
  setOpenModal,
  openModal,
}) => {
  return (
    <>
      <Modal
        centered
        title={
          <>
            <CredusText size="md" weight="medium">
              Confirm Action
            </CredusText>
          </>
        }
        open={openModal}
        footer={false}
        onOk={() => setOpenModal(false)}
        onCancel={() => setOpenModal(false)}
        width={480}
      >
        <Divider style={{ margin: '29px 0px 0px' }} />
        <Container>
          <NotifyWrap>
            <CredusText size="lg" weight="regular" align="center">
              You’re about to logout from this device. Do you want to proceed ?
            </CredusText>
          </NotifyWrap>
          <CredusWrapper mt=".8rem" display="flex" justify="center">
            <CredusWrapper mb="4rem" display="flex" gap="1.4rem">
              <CredusButton onClick={onSignOutModalOpen} variant="primary">
                Yes, logout
              </CredusButton>
              <CredusButton onClick={onSignOutModalOpen} variant="secondary">
                Cancel
              </CredusButton>
            </CredusWrapper>
          </CredusWrapper>
        </Container>
      </Modal>
    </>
  );
};

export default SignOutModal;

const Container = styled.div`
  padding: 0rem 0.8rem;
`;

const NotifyWrap = styled.div`
  margin-top: 49px;
  margin-bottom: 63px;
  text-align: center;
`;
